import React, { FormEvent } from 'react'
import MyPageView from 'src/pages/Mypage/view'
import { useCookies } from 'react-cookie'
import { useToast } from 'src/provider/ToastContextProvider'
import { useGlobalStore } from 'src/store/zustand'
import usePageNav from 'src/hooks/usePageNav.hook'
import { useChannel } from 'src/provider/ChannelContextProvider'

export interface MyPageProps {
  couponManagementListItems: MypageListItemsType[]
  helpCenterListItems: MypageListItemsType[]
}

export type MypageListItemsType = {
  path: string
  text: string
  onClickFn?: (event: FormEvent<HTMLAnchorElement>) => void
}

const MyPage = () => {
  const { web } = useChannel()
  const { openToast } = useToast()
  const { addUtmParameter, introPageNav } = usePageNav()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_cookies, _setCookie, removeCookie] = useCookies(['u-tel', 'auth-key'])
  const { resetPurchaseHistoryUnderLineTab } = useGlobalStore()

  const couponManagementListItems = [
    {
      path: addUtmParameter(`/coupon/purchase_history`),
      text: '쿠폰지갑 구매내역',
      onClickFn: () => resetPurchaseHistoryUnderLineTab(),
    },
    { path: addUtmParameter(`/coupon/self_register`), text: '직접등록한 쿠폰' },
    { path: addUtmParameter(`/coupon/free_coupon`), text: '혜택' },
    // { path: addUtmParameter(`/setting/notify`), text: '알림설정' },
    ...(web
      ? []
      : [
          {
            path: addUtmParameter(`/setting/easy_login`),
            text: '간편 비밀번호 설정',
          },
        ]),
  ]

  const helpCenterListItems = [
    { path: addUtmParameter(`/help_center/notice`), text: '공지사항' },
    { path: addUtmParameter(`/help_center/faq`), text: '자주 묻는 질문' },
    { path: addUtmParameter(`/help_center/qna`), text: '1:1 문의' },
    { path: addUtmParameter(`/help_center/terms`), text: '이용약관' },
    { path: addUtmParameter(`/cancel`), text: '서비스 해지' },
    {
      path: addUtmParameter(`/intro`),
      text: '로그아웃',
      onClickFn: () => {
        openToast({ contents: '로그아웃 되었습니다.' })
        introPageNav()
      },
    },
  ]

  const props: MyPageProps = {
    couponManagementListItems,
    helpCenterListItems,
  }

  return <MyPageView {...props} />
}
export default MyPage
